<template>
    <gofix-card title="Action taken" class="h-100" classHeader="mb-25 pr-42" classContent="mb-20">
        <template slot="gofixCard:right_header">
            <span v-if="isAllowEditActionTaken" class="editBox position-static cursor-pointer" @click="editActionTaken">
                <img src="img/iconPencil.png" alt width="18" height="18"/>
            </span>
        </template>
        <b-row>
            <b-col md="6">
                <gofix-text-field label="Description" oneline>
                    <span v-html="Item.action_taken && Item.action_taken.description ? Item.action_taken.description.replaceAll('\n', '<br>') : ''"></span>
                </gofix-text-field>
            </b-col>
            <b-col md="6" class="photosThumb mt-0">
                <gofix-text-field label="photos" oneline>
                    <template v-if="Item.action_taken && Item.action_taken.attachments">
                        <viewer-image :images="Item.action_taken.attachments" classViewer='d-flex align-items-center'>
                            <template slot="gofixViewer:list_image" ref="viewerActionTaken" slot-scope="{images}">
                                <ul class="list-thumb checklist">
                                    <template v-for="(item, key) in images">
                                        <li v-if="key <= (limitImage + 1 )" :class="{'d-none': key > (limitImage-1)}" v-bind:key="key">
                                            <img v-auth-image="item.url.original" :alt="item.image_file_name" :key="item.url.original"  src="img/loading.gif">
                                        </li>
                                    </template>
                                </ul>
                                <template v-if="images.length > limitImage">
                                    <div class="attachmentsColumn cursor-pointer pl-0">
                                        <div class="item-content bg-transparent pd-0">
                                            <img class="image-viewer" v-auth-image="images[images.length-1].url.original"  src="img/loading.gif">
                                            <span class="checklist-photo-custom" v-if="images.length > limitImage">+{{ images.length - limitImage }}</span>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </viewer-image>
                    </template>
                </gofix-text-field>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="action taken" hide-footer :centered="true" ref="modal-edit-action-taken" @close="() => {
            this.action_taken_del_ids = [];
            this.imgActionTakenAction.photos = [];
        }">
            <b-form class="pb-10">
                <gofix-form-input-textarea label="Description" :rows="5" v-model="action_taken.description"></gofix-form-input-textarea>
                <b-form-group label="photos 1" class="photosThumb clear-both">
                    <ul class="list-thumb">
                        <li v-for="(item,key) in action_taken.attachments" v-bind:key="key">
                            <img v-auth-image="item.url.thumb" src="img/loading.gif" alt />
                            <span class="delete" @click="deleteImgActionTaken(item)">
                                <img src="img/close.png" alt />
                            </span>
                        </li>
                    </ul>
                    <div class="upload-btn-wrapper">
                        <b-form-file accept="image/jpeg, image/png, image/gif" id="fileInputMulti" v-model="imgActionTaken" :plain="true" :multiple="true"></b-form-file>
                        <gofix-button class="m-3" label="add photo" outline></gofix-button>
                    </div>
                </b-form-group>
            </b-form>

            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="updateActionTaken" :loading="isAction" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>

<script>
    import { mapGetters } from 'vuex';
    const ViewerImage = () => import('../plugins/ViewerImage.vue')
    import moment from 'moment';
    
    export default {
        name: 'check-list-report',
        components: {
            ViewerImage
        },
        data() {
            return{
                isAction: false,
                isActionFollowUp: false,
                limitImage: 14,
                imgWorkFinding: null,
                imgWorkFindingAction: {
                    photos: [],
                    delete: [],
                },
                work_finding_del_ids: [],
                work_finding: {
                    attachments: [],
                    description: "",
                    remark_type: "JobWorkFinding",
                },
                imgActionTaken: null,
                imgActionTakenAction: {
                    photos: [],
                    delete: [],
                },
                action_taken_del_ids: [],
                action_taken: {
                    attachments: [],
                    description: "",
                    remark_type: "JobActionTaken",
                },
            }
        },
        computed: {
            ...mapGetters({
                Item: "JobController/Item"
            }),
            isAllowEditActionTaken() {
                if(!this.Item || !this.Item.editing_of_job_data_action || !this.Item.editing_of_job_data_action.is_allow_edit_action_taken) return false;
                return true;
            }
        },
        mounted() {
            this.$nextTick(function () {
                window.addEventListener('resize', this.handleResize);
            })
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        created() {
            this.handleResize();
        },
        watch: {
            imgWorkFinding(val, old) {
                if (val) {
                    val.forEach((file) => {
                        if (
                            file.type != "image/jpeg" &&
                            file.type != "image/png" &&
                            file.type != "image/gif"
                        ) {
                            this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                            return;
                        }
                        file.moment = moment().valueOf();
                        let data = {
                            moment: moment().valueOf(),
                            url: {
                                original: URL.createObjectURL(file),
                                medium: URL.createObjectURL(file),
                                thumb: URL.createObjectURL(file),
                            },
                        };

                        this.imgWorkFindingAction.photos.push(file);
                        this.work_finding.attachments.push(data);
                    });
                }
            },
            imgActionTaken(val, old) {
                if (val) {
                    val.forEach((file) => {
                        if (
                            file.type != "image/jpeg" &&
                            file.type != "image/png" &&
                            file.type != "image/gif"
                        ) {
                            this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                            return;
                        }
                        file.moment = moment().valueOf();
                        let data = {
                            moment: moment().valueOf(),
                            url: {
                                original: URL.createObjectURL(file),
                                medium: URL.createObjectURL(file),
                                thumb: URL.createObjectURL(file),
                            },
                        };
                        this.imgActionTakenAction.photos.push(file);
                        this.action_taken.attachments.push(data);
                    });
                }
            },
        },
        methods: {
            handleResize() {
                this.limitImage = 14;
                if (window.innerWidth < 1700) {
                    this.limitImage = 12
                }

                if (window.innerWidth < 1450) {
                    this.limitImage = 10
                }

                if (window.innerWidth < 1300) {
                    this.limitImage = 8
                }
            },
            /* --- Action Taken --- */
            editActionTaken() {
                this.isAction = false;
                let data = JSON.parse(JSON.stringify(this.Item));
                if (data.action_taken) {
                    this.action_taken = data.action_taken;
                } else {
                    this.action_taken.attachments = [];
                    this.action_taken.description = '';
                }
                this.$refs["modal-edit-action-taken"].show();
            },
            updateActionTaken() {
                if (this.isAction) return;
                this.isAction = true;
                this.$store
                    .dispatch("JobController/updateRemarks", {
                        data: this.action_taken,
                        id: this.Item.id,
                        action: this.imgActionTakenAction,
                    })
                    .then((result) => {
                        (this.imgActionTakenAction = {
                            photos: [],
                            delete: [],
                        });

                        if(this.action_taken_del_ids.length > 0) {
                            this.$store.dispatch("JobController/deleteAttachments",{ids : this.action_taken_del_ids, action : 'action_taken' })
                            .then(result => {
                              this.action_taken_del_ids = [];
                            })
                        }

                        this.$alertNotification(this.$notificationV2("editing", "checklist"));
                        this.$refs["modal-edit-action-taken"].hide();
                    }).catch(error => {
                        this.isAction = false;
                    });
            },
            deleteImgActionTaken(img) {
                if (img.moment) {
                    this.action_taken.attachments = this.action_taken.attachments.filter(
                        (item) => item.moment != img.moment
                    );
                    this.imgActionTakenAction.photos = this.imgActionTakenAction.photos.filter(
                        (item) => item.moment != img.moment
                    );
                } else {
                    //  this.imgActionTakenAction.delete.push(img.id);
                    this.action_taken.attachments = this.action_taken.attachments.filter(
                        (item) => item.id != img.id
                    );
                    this.action_taken_del_ids.push(img.id);
                }
            }
        }
    }
</script>
